/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SecurityFindingSourceDetailsForDockle {
    getFixupPrototypeFunction() { return SecurityFindingSourceDetailsForDockle.fixupPrototype; }

    static newInstance(model: Partial<SecurityFindingSourceDetailsForDockle>): SecurityFindingSourceDetailsForDockle {
        let obj = Object.assign(new SecurityFindingSourceDetailsForDockle(), model);
        SecurityFindingSourceDetailsForDockle.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SecurityFindingSourceDetailsForDockle>): SecurityFindingSourceDetailsForDockle {
        if (!model) return null;
        return SecurityFindingSourceDetailsForDockle.newInstance(<SecurityFindingSourceDetailsForDockle> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SecurityFindingSourceDetailsForDockle) {
        if (!obj) return;

        models.SecurityFindingSourceDetailsForDockle.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SecurityFindingSourceDetailsForDockle): boolean {
        Object.setPrototypeOf(obj, SecurityFindingSourceDetailsForDockle.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.summary) {
            models.ContainerFindingDockleSummary.fixupPrototype(this.summary);
        }
        if (this.details) {
            for (let val of this.details) {
                models.ContainerFindingDockleDetails.fixupPrototype(val);
            }
        }
    }

    /**
     * Name and tag of the container image that was scanned by Dockle for security issues
     */
    image: string;

    /**
     * Statistical summary of all security findings categorized by severity level
     */
    summary: models.ContainerFindingDockleSummary;

    /**
     * Detailed list of individual security findings discovered during the Dockle scan
     */
    details: Array<models.ContainerFindingDockleDetails>;

}
